import styled from 'styled-components';

export const StyledContainer = styled.div`
  input[type='file'] {
    position: absolute;
    margin: -1px;
    width: 1px;
    height: 1px;
    border: 0;
    clip: rect(0, 0, 0, 0);
    overflow: hidden;
  }
  margin-bottom: 2rem;
`;
